const _ = require('underscore');
const moment = require('moment-timezone');

export function addCollaborator(state, { showId, collaboration, user }) {
  const nextState = { ...state };

  if (!nextState[showId]) nextState[showId] = [];

  const currentIndex = _.findIndex(nextState[showId], (collaborator) => {
    return collaborator.user._id === user._id;
  });

  const newCollaborator = {
    collaboration,
    user,
    expires: moment().add(30, 'minutes').valueOf(),
  };

  if (currentIndex !== -1) {
    nextState[showId][currentIndex] = newCollaborator;
  } else {
    nextState[showId].push(newCollaborator);
  }

  return nextState;
}

export function clearExpiredCollaborators(state) {
  const nextState = { ...state };

  return _.mapObject(nextState, (show) => {
    return show.filter((collab) => {
      return moment(collab.expires).isAfter(moment());
    });
  });
}
